var path = 'components/subscribers/activation/tooltips/paypalPaymentSystem.html';
var html = "<div><b>Payment method:</b> PayPal</div> <div ng-if=purchase.$captureId><b>Transaction ID:</b> <span ng-bind=purchase.$captureId></span></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;